import React from 'react';
import { List, Typography, Divider } from '@mui/material';
import HistoryListItem from './HistoryListItem';
import { useTranslation } from 'react-i18next';

// 그룹 키를 번역 키로 매핑
const getGroupTranslationKey = (group) => {
  const keyMap = {
    '오늘': 'drawer.today',
    '어제': 'drawer.yesterday',
    '지난 7일': 'drawer.lastWeek',
    '지난 30일': 'drawer.lastMonth'
  };
  return keyMap[group] || group;
};

const HistoryGroupList = ({
  grouped,
  history,
  selectedHistoryId,
  setSelectedHistoryId,
  setAnalyzedVideoId,
  setAnalyzedTitle,
  setAnalyzedUrl,
  setDrawerOpen,
  isDesktop,
  projectSubMenuRefs,
  historyMenuRefs,
  setHistoryMenuAnchor,
  setHistoryMenuIdx,
  projects,
  handleAddHistoryToProject,
  handleEditHistory,
  handleDeleteClick,
  menuOpenIdx,
  setMenuOpenIdx,
  setHistory
}) => {
  const { t } = useTranslation();
  
  return (
  <List sx={{ p: 0 }}>
    {['오늘', '어제', '지난 7일', '지난 30일'].map(group => (
      grouped[group] && grouped[group].length > 0 && (
        <React.Fragment key={group}>
          <Divider sx={{ mt: 2, mb: 1 }} />
          <Typography sx={{ fontSize: 13, color: '#555', fontWeight: 700, mb: 1, letterSpacing: 0.5, pl: 1 }}>{t(getGroupTranslationKey(group))}</Typography>
          {grouped[group].map((item, idx) => {
            const ref = el => {
              if (item.id) {
                projectSubMenuRefs.current[item.id] = el;
                historyMenuRefs.current[item.id] = el;
              }
            };
            return (
              <HistoryListItem
                key={item.id || idx}
                item={item}
                idx={idx}
                selected={selectedHistoryId === item.id}
                onSelect={() => {
                  // 상태 변경 없이 드로어만 닫기
                  // 실제 네비게이션은 HistoryListItem에서 처리
                  setDrawerOpen && setDrawerOpen(false);
                }}
                onMoreClick={e => {
                  e.stopPropagation();
                  setHistoryMenuAnchor(historyMenuRefs.current[item.id]);
                  setHistoryMenuIdx(item.id);
                }}
                refFn={ref}
                projects={projects}
                handleAddHistoryToProject={handleAddHistoryToProject}
                handleEditHistory={handleEditHistory}
                handleDeleteClick={handleDeleteClick}
                menuOpenIdx={menuOpenIdx}
                setMenuOpenIdx={setMenuOpenIdx}
                listIdx={idx}
                setHistory={setHistory}
                setAnalyzedVideoId={setAnalyzedVideoId}
                setAnalyzedTitle={setAnalyzedTitle}
                setAnalyzedUrl={setAnalyzedUrl}
                setDrawerOpen={setDrawerOpen}
              />
            );
          })}
        </React.Fragment>
      )
    ))}
    {/* 이전(월별) 그룹 */}
    {Object.entries(grouped['이전']).map(([month, items]) => (
      <React.Fragment key={month}>
        <Divider sx={{ mt: 2, mb: 1 }} />
        <Typography sx={{ fontSize: 13, color: '#555', fontWeight: 700, mb: 1, letterSpacing: 0.5, pl: 1 }}>{month}</Typography>
        {items.map((item, idx) => (
          <HistoryListItem
            key={item.id || idx}
            item={item}
            idx={idx}
            selected={selectedHistoryId === item.id}
            onSelect={() => {
              // 상태 변경 없이 드로어만 닫기
              // 실제 네비게이션은 HistoryListItem에서 처리
              setDrawerOpen && setDrawerOpen(false);
            }}
            onMoreClick={e => {
              e.stopPropagation();
              setHistoryMenuAnchor(historyMenuRefs.current[item.id]);
              setHistoryMenuIdx(item.id);
            }}
            refFn={el => {
              if (item.id) {
                projectSubMenuRefs.current[item.id] = el;
                historyMenuRefs.current[item.id] = el;
              }
            }}
            projects={projects}
            handleAddHistoryToProject={handleAddHistoryToProject}
            handleEditHistory={handleEditHistory}
            handleDeleteClick={handleDeleteClick}
            menuOpenIdx={menuOpenIdx}
            setMenuOpenIdx={setMenuOpenIdx}
            listIdx={idx}
            setHistory={setHistory}
            setAnalyzedVideoId={setAnalyzedVideoId}
            setAnalyzedTitle={setAnalyzedTitle}
            setAnalyzedUrl={setAnalyzedUrl}
            setDrawerOpen={setDrawerOpen}
          />
        ))}
      </React.Fragment>
    ))}
  </List>
  );
};

export default HistoryGroupList; 